import serviceDocument from "../../services/patient/DocumentService";
import PatientService from "../../services/patient/PatientService";
import i18n from "../../i18n/index";
import { StorageService } from "../../services/StorageService";
import serviceCalendar from "../../services/calendarAppointment/serviceCalendar";
import dayjs from "dayjs";
import AppointmentService from "../../services/appointment/ServiceAppointment";
import appointmentList from "./appointmentList/appointmentList.vue";
import locationService from '../../services/location/LocationService.js'
import deliveryPointService from '../../services/delivery-point/DeliveryPointService'
import parametersService from '../../services/parameters/ParametersService'
import pendingReasonsService from './../../services/pending-reasons/PendingReasonsService.js'
import serviceOrder from "../../services/orders/OrderService.js";
import kardex from "../../services/kardex/kardex-medicine.js";

export default {
    components: {
        appointmentList
    },
    data: () => ({
        showGrid: true,
        panel: [],
        menuDelivery: false,
        providers: [],
        observation: "",
        patientListData: [],
        disableSaveButton: false,
        menu: false,

        rules: { required: value => !!value || "El campo es requerido" },
        states: [],
        cities: [],
        documentTypeItems: [],
        orderPatient: [],
        patient: {
            id: "",
            type: "",
            document: "",
            fullname: "",
            address: "",
            cellPhoneNumber: "",
            phoneNumber: ""
        },
        dialog: false,
        idOrderAppointment: "",
        buttonDisabled: false,
        state: '',
        city: '',
        deliveryPoint: '',
        address: '',
        appointmentDate: '',
        minDate: '',
        scheduleRanges: [],
        scheduleRange: '',
        pendingReasonItems: [],
        status: '',
        newAppointment: true,
        userIsAdmin: false,
        id: '',
        cancelReasons: [],
        cancelReasonToShow: '',
        selectedDP: {
            name: '',
            address: ''
        },
        selectedSR: {
            range: ''
        },
        typeCancelAuthorization: [],
        loadingSave: false,
        loadingEdit: false,
        headers: [
            {
              sortable: false,
              text: i18n.t("headers.order-detail-number"),
              value: "orderCode",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.plu"),
              value: "plu",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.description"),
              value: "description",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.qty"),
              value: "count",
              align: "left",
            },
            {
                sortable: false,
                text: "CANT ENTREGADA",
                value: "deliveredCount",
                align: "left",
                showColumn: function() {
                    return this.status === 'SCHEDULED' || this.status === 'AGENDADA' ;
                }
              },
              {
                sortable: false,
                text: "CANT PENDIENTE",
                value: "pendingmedicine",
                align: "left",
                showColumn: function() {
                    return this.status === 'SCHEDULED' || this.status === 'AGENDADA' ;
                }
              },
              {
                sortable: false,
                text: "MOTIVO",
                value: "pendingReason",
                align: "left",
                showColumn: function() {
                    return this.status === 'SCHEDULED' || this.status === 'AGENDADA' ;
                }
              },
            {
              sortable: false,
              text: "MOTIVO CANCELACIÓN",
              value: "typeCancelAuthorization",
              align: "left",
            }
        ],
        
        medicines: [],
        userWithAuthorizations: false,
        noteText: ''
    }),
    created () {
        this.getPendingReason()
    },

    async mounted () {
        this.getDocumentTypes();
        this.getStates();
        await this.validateUser();
        await this.getNoteText();
        this.getCancelReasons()
    },

    methods: {
        changeCancelReason(medicine) {
            if (medicine.typeCancelAuthorization === undefined) {
                this.dataMedicines.forEach((med) => {
                    if (med.orderCode === medicine.orderCode) {
                        med.check = true
                        med.typeCancelAuthorization = ''
                        med.datePreviewDelivery = ''
                    }
                });
                this.validateOrderDetail();
                return
            }
            let cancelReason = medicine.typeCancelAuthorization
            this.dataMedicines.forEach((med) => {
                if (med.orderCode === medicine.orderCode) {
                    med.check = false
                    if (cancelReason === 'Previamente entregado') {
                        med.datePreviewDelivery = medicine.datePreviewDelivery
                    } else {
                        med.datePreviewDelivery = ''
                    }
                    med.typeCancelAuthorization = cancelReason
                }
            })
            this.validateOrderDetail();
        },
        getItemSelectedReason(reason) {
            let list = null;
            switch (reason) {
                case "Orden anulada":
                    list = this.typeCancelAuthorization[0];
                    break;
                case "Orden vencida":
                    list = this.typeCancelAuthorization[1];
                    break;
                case "Previamente entregado":
                    list = this.typeCancelAuthorization[2];
                    break;
                case "Solicitud del paciente":
                    list = this.typeCancelAuthorization[3];
                    break;
                case "Duplicidad":
                    list = this.typeCancelAuthorization[4];
                    break;
                case "El medicamento debe ser reclamado en farmacia":
                    list = this.typeCancelAuthorization[5];
                    break;
                case "Dirección Errada":
                    list = this.typeCancelAuthorization[6];
                    break;
                case "Tutela":
                    list = this.typeCancelAuthorization[7];
                    break;
                case "Zona sin cobertura":
                    list = this.typeCancelAuthorization[8];
                    break;
            }
            return list;
        },
        async validationAfterChangeQuantity(medicine) {
            medicine.deliveredCount = parseInt(medicine.deliveredCount) || 0;
         },
         validationAfterChangeQuantity(medicine) {
          
            this.updateEnablePendingReason(medicine)
        },
        maxNumberOfField(medicine) {
            // this.orderDetails.forEach(order => {

                if (medicine.deliveredCount > this.medicine.count) {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'El numero de la cantidad entregada no debe ser superior al de la cantidad.'
                    })
                }
            // });
        },
        updateEnablePendingReason(medicine) {
            console.log("medicine",medicine);
            medicine.deliveredCount =medicine.deliveredCount > -1 ? medicine.deliveredCount : 0

            medicine.deliveredCount=medicine.deliveredCount> medicine.count ?medicine.count :medicine.deliveredCount
            medicine.enablePendingReason =medicine.count -medicine.deliveredCount !== 0

            if (parseInt(medicine.deliveredCount) === medicine.count) {
                medicine.pendingReason = 0
            }

            // this.updateSlidingScaleFee()
        },
        addMedicines(validate, medicineId, medicineCondition) {
            if (!validate) {
                const foundOrder = this.foundCurrentOrder(this.selectOrderCode);
                this.isFeatured =
                    this.isFeatured ||
                    (medicineCondition ? medicineCondition.isFeatured : false);
                this.isApplicable =
                    this.isApplicable ||
                    (medicineCondition ? medicineCondition.isApplicable : false);
                this.isWatched =
                    this.isWatched ||
                    (medicineCondition ? medicineCondition.isWatched : false);
                const patientNameAux = this.order.id ? foundOrder.patientName : this.patient.fullname
                const patientIdentificationAux = this.order.id ? foundOrder.patientIdentification : this.patient.document
                    /**TODO: Llenado de Tabla */
                if (this.cancelReason !== "" && this.cancelReason !== null && this.cancelReason !== undefined) {
                    let cancelReasonInArray = this.typeCancelAuthorization.find(cr => cr.name === this.cancelReason)
                    if (!cancelReasonInArray) {
                        this.typeCancelAuthorization.push({
                            name: this.cancelReason
                        })
                    }
                }
                this.dataMedicines.push({
                    check: this.getCheckMedicine(
                        foundOrder.status,
                        medicineCondition ? medicineCondition.isApplicable : false,
                        medicineCondition ? medicineCondition.isWatched : false,
                        medicineCondition ? medicineCondition.isFeatured : false
                    ),
                    fullname: patientNameAux,
                    document: patientIdentificationAux,
                    id: medicineId,
                    plu: this.plu,
                    description: this.description,
                    count: this.count,
                    deliveredCount: this.count,
                    pendingmedicine:this.count-deliveredCount,
                    nextShippingDate: this.nextShippingDate,
                    orderCode: this.selectOrderCode,
                    providerName: foundOrder.initialProvider ? foundOrder.initialProvider.name : foundOrder.providerName,
                    providerId: foundOrder.initialProvider ? foundOrder.initialProvider.id : foundOrder.providerId,
                    scaleFee: foundOrder.scaleFee,
                    deliveryNumber: foundOrder.deliveryNumber,
                    status: foundOrder.status,
                    paymentType: foundOrder.paymentType,
                    isApplicable: medicineCondition ?
                        medicineCondition.isApplicable : false,
                    isWatched: medicineCondition ? medicineCondition.isWatched : false,
                    isFeatured: medicineCondition ? medicineCondition.isFeatured : false,
                    // typeCancelAuthorization: this.cancelReason,
                    typeCancelAuthorization: this.cancelReason === "" ?
                        this.getSelectedMedince(
                            medicineCondition ? medicineCondition.isApplicable : false,
                            medicineCondition ? medicineCondition.isWatched : false,
                            medicineCondition ? medicineCondition.isFeatured : false
                        ) : this.cancelReason,
                    datePreviewDelivery: this.datePreviewDelivery !== null ? this.datePreviewDelivery.split('T')[0] : '',
                    datePicker: false
                });

                foundOrder.medicines = this.dataMedicines.filter(
                    m => m.orderCode === this.selectOrderCode
                );

                if (foundOrder.status ||
                    foundOrder.status != 'NO_STATUS' ||
                    foundOrder.status != 'SCHEDULED') {
                    this.validateMedicine(this.dataMedicines)
                    console.log(" this.dataMedicinessssss", this.dataMedicines)
                }

                if (this.isNewOrder) {
                    this.updateOrderType();
                }

                this.$emit("dataMedicines", this.dataMedicines);
            
            }
        },
        async handleOrder(order, shippingFee, slidingScaleFee, invoice) {
            try {
               
                let response = await serviceOrder.getOrderWithId(order.id, false)
                order = response.data
console.log("order",order)
                for (let i = 0; i < order.length; i++) {
                    const result = order[i];
                    // Realiza las operaciones necesarias con result
                    
                    // Incrementa deliveredCount solo si se cumple cierta condición
                    if (result.condition) {
                        this.medicines.deliveredCount++;
                    }
                }

                // if (invoice) {
                //   try {
                //     let response = await CheckInOrderService.getQuantities(
                //       { facturaNumber: invoice }
                //     )
                //     this.dispatches = response.data
                //   } catch (error) {
                //     this.$notify({
                //       group: 'app',
                //       type: 'error',
                //       text: 'Error consultando las cantidades facturadas'
                //     })
                //   }
                // } else {
                //   try {
                //     let response = await CheckInOrderService.getQuantitiesNoInvoice(
                //       { id: order.id }
                //     )
                //     this.dispatches = response.data
                //   } catch (error) {
                //     this.$notify({
                //       group: 'app',
                //       type: 'error',
                //       text: 'Error consultando las cantidades facturadas'
                //     })
                //   }
                // }

                if (order.id) {
                    this.attachments = []
                    for (let i = 0; i < order.attachments.length; i++) {
                        const attachment = order.attachments[i];
                        const arr = new Uint8Array(attachment.data.data);
                        const blob = new Blob([arr], { type: 'application/pdf' });
                        let fileURL = window.URL.createObjectURL(blob);
                        this.URLAttachments.push(fileURL)
                        this.attachments.push({ name: attachment.fileName })
                    }
                    this.showDownloadAttachment = true
                }

                let orderSlidingScaleFee = 0
                for (let i = 0; i < order.orderDetails.length; i++) {
                    if (order.orderDetails[i].status != 'CANCELED' || order.orderDetails[i].status != 'RETURNED') {
                        orderSlidingScaleFee += order.orderDetails[i].slidingScaleFee
                    }
                }
                if (this.dispatches.length > 0) {
                    try {
                        for (let j = 0; j < order.orderDetails.length; j++) {
                            const od = order.orderDetails[j]
                            let filteredDispatches = this.dispatches.filter(dispatch => {
                                return dispatch.order === od.code
                            })
                            if (filteredDispatches.length > 0) {
                                for (let i = 0; i < od.orderDetailMedicines.length; i++) {
                                    const medicine = od.orderDetailMedicines[i]
                                    let auxMedicine
                                    let auxDispatch = []
                                    for (let k = 0; k < filteredDispatches.length; k++) {
                                        let medicinesObject = filteredDispatches[k].medicines
                                        for (let m = 0; m < medicinesObject.length; m++) {
                                            const med = medicinesObject[m];
                                            if (medicine.pluCode === med.cdSura) {
                                                auxDispatch.push(filteredDispatches[k])
                                            }
                                        }
                                    }
                                    auxDispatch = auxDispatch.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
                                    if (auxDispatch.length > 0) {
                                        this.dispatchesToSave.push(auxDispatch[0])
                                        let medicinesObject = auxDispatch[0].medicines
                                        for (let m = 0; m < medicinesObject.length; m++) {
                                            const med = medicinesObject[m]
                                            if (medicine.pluCode === med.cdSura) {
                                                auxMedicine = med
                                                order.orderDetails[j].orderDetailMedicines[i].deliveredQuantity = auxMedicine.nmCantidadEntregaAcum || 0
                                                order.orderDetails[j].orderDetailMedicines[i].invoice = auxDispatch[0].invoice || ''
                                                order.orderDetails[j].orderDetailMedicines[i].idPendingReason = auxMedicine.cdMotivoEntregaParcial || ''
                                            }
                                        }
                                    }
                                    if (auxMedicine === undefined) {
                                        this.$notify({
                                            group: 'app',
                                            type: 'error',
                                            text: `No se ha encontrado facturas relacionadas con el medicamento de plu ${medicine.pluCode} en la orden ${od.code}`
                                        })
                                    }
                                }
                            } else {
                                this.$notify({
                                    group: 'app',
                                    type: 'error',
                                    text: `No se ha encontrado facturas relacionadas con la orden ${od.code}`
                                })
                            }

                            let filteredDispatches2 = this.dispatchesToSave.filter(dispatch => {
                                return dispatch.order === od.code
                            })

                            if (filteredDispatches2.length > 0) {
                                order.orderDetails[j].slidingScaleFee = filteredDispatches2.reduce((a, b) => a + b.value, 0)
                            }
                        }
                    } catch (error) {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: 'Error procesando información de facturas'
                        })
                    }
                }
                let responseAlreadyCheckIn = await CheckInOrderService.alreadyCheckIn({ orderId: order.id })
                this.alreadyCheckIn = responseAlreadyCheckIn.data
                this.showGrid = !this.showGrid
                this.orderId = order.id
                this.order = order
                if (this.providerId !== 2) {
                    this.showInvoice = false
                    this.headers.splice(3, 1)
                }
                let aux = []
                for (const od of order.orderDetails) {
                    if (!aux.includes(od.initialProvider.id)) {
                        aux.push(od.initialProvider.id)
                        this.providerList.push({ id: od.initialProvider.id, name: od.initialProvider.name })
                    }
                }
                this.orderDetails = this.translateOrderDetailMedicines(
                    order.orderDetails
                )
                this.shippingFee = shippingFee
                this.slidingScaleFee = Math.ceil(orderSlidingScaleFee)
                order.slidingScaleFee = Math.ceil(orderSlidingScaleFee)
                order.orderDetailBarCodes = order.orderDetailBarCodes || []
                    // if (this.providerId === 8) {
                this.documentCount = order.orderDetailBarCodes.filter(
                        odbc =>
                        !this.isProviderPresent || odbc.idProvider.id === this.providerId
                    ).length
                    // } else {
                    //   this.documentCount = order.orderDetailBarCodes.filter(
                    //     odbc =>
                    //       !this.isProviderPresent || odbc.initialProvider.id === this.providerId
                    //   ).length
                    // }
                this.barcodesByProvider = {}
                this.barcodes = []
                for (let provider of this.providerList) {
                    this.barcodesByProvider[provider.id] = order.orderDetailBarCodes.map(barcode => {
                        if (!this.barcodes.includes(barcode.barCode)) {
                            this.barcodes.push(barcode.barCode)
                        }
                        if (barcode.initialProvider) {
                            if (barcode.initialProvider.id === provider.id) {
                                return barcode.barCode
                            }
                        }
                    })
                    this.barcodesByProvider[provider.id] = this.barcodesByProvider[provider.id].filter(barcode => barcode !== undefined)
                }
                this.providerBarcodes = this.barcodesByProvider
                this.showBarcodeModal = true
                this.patients = order.orderPatients.map(op => op.idPatient)
                    // console.log('name: ', order.idUserScheduling)
                if (order.idUserScheduling === null) {
                    this.UserScheduling = ''
                } else {
                    this.UserScheduling = order.idUserScheduling.name
                }
                let userId = await this.getUserId();
                let data = {
                    orderId: order.id,
                    providerId: this.providerId ? this.providerId : 1,
                    userId: userId
                }
                await OrderEditionService.registerOrderEdition(data)
            } catch (error) {
                console.log(error)
                if (error.code && error.code === 'ORDER_IS_ALREADY_EDITING') {
                    this.cancelCheckIn()
                    this.cancelEditing = true

                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: i18n.t('app.general.order-is-already-in-use')
                    })
                } else {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: error
                    })
                }
            }
        },
        async getUserId() {
            let userId = await StorageService.getUserData().id;
            if (!userId || typeof userId === 'string') {
                if (this.userInfo) {
                    userId = this.userInfo.id
                }
                userId = 0
            }
            return userId
        },
        async handleOrder(order) {
            console.log("entro en sheduling")
            this.loading = true
            if (order.id) {
                let user = JSON.parse(localStorage.getItem("user"));

                let response = await serviceOrder.getOrderWithId(order.id, true)
                order = response.data

                this.isNewOrder = false;
                if (
                    parseInt(StorageService.getUserData().rol) === 1005
                ) {
                    this.disableSaveButton = true;
                    this.nameDissabled = true;
                } else if (order.status !== "SCHEDULED") {
                    this.disableSaveButton = true;
                    this.nameDissabled = true;
                }
            }

            if (order.idSura) {
                this.orderFromSura = true
                this.addressFromSura = order.shippingAddress
            }



            let isItLoaded = false;
            // this.getAllowedDate();
            order.orderPatients.forEach(orderPatient => {
                let patient = orderPatient.idPatient;
                if (
                    this.patientListData.some(
                        p =>
                        p.documentType === patient.idIdentificationType.id &&
                        p.document === patient.identification
                    )
                ) {
                    isItLoaded = true;
                }
            });

            if (isItLoaded) return false;

            this.showGrid = true
            this.showGridAppointment = false

            // const userData = StorageService.getUserData()
            // if (order.status !== 'RETURNED' && order.status !== 'SCHEDULED') this.disableSaveButton = true

            this.order.deliveryAddress = '';
            this.nameNomenclature = '';
            this.numberOne = '';
            this.numberTwo = '';
            this.numbreThree = '';

            this.typeProperty = '';
            this.observationOne = '';
            this.blockOrInterior = '';
            this.observationTwo = '';

            if (order.id) {
                this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`;
                this.nameNomenclature = order.nameNomenclature;
                this.numberOne = order.numberOne;
                this.numberTwo = order.numberTwo;
                this.numbreThree = order.numbreThree;

                this.typeProperty = order.typeProperty;
                this.observationOne = order.observationOne;
                this.blockOrInterior = order.blockOrInterior;
                this.observationTwo = order.observationTwo;

            }

            this.createReminder = order.reminders && order.reminders.length > 0;
            this.order.id = order.id;
            this.order.status = order.status;
            if (order.type !== "NO_STATUS") {
                switch (order.type) {
                    case "EXCLUSIVE":
                        this.order.orderType = this.itemTypeOrder[0].id;
                        break;
                    case "INTEGRATED":
                        this.order.orderType = this.itemTypeOrder[1].id;
                        break;
                }
            }
            this.order.number = order.number;
            this.order.notApplyShippingFee = order.notApplyShippingFee;

            this.selectedScheduleRange = order.idProviderScheduleRange ?
                order.idProviderScheduleRange.id + "" :
                "";

            if (!this.authorizationsLoaded) {
                this.patientListData = [];
                this.orderDetail = [];
            }
            order.orderPatients.forEach(orderPatient => {
                let patient = orderPatient.idPatient;
                this.patientListData.push({
                    id: patient.id,
                    documentType: patient.idIdentificationType.id,
                    document: patient.identification,
                    fullname: patient.name,
                    address: patient.address,
                    mobilePhone: patient.mobilePhone,
                    phone: patient.phone,
                    idIncomeGroup: patient.idIncomeGroup ? patient.idIncomeGroup.id : "-",
                    isPac: +patient.PAC === 1,
                    isPolicy: +patient.policy === 1
                });
                
            });

            // this.patientListData.forEach(p => {
            //   if (p.mobilePhone == '' || p.mobilePhone == null || p.mobilePhone == undefined || p.phone == '' || p.phone == null || p.phone == undefined) {
            //     this.disableSaveButton = true;
            //   }
            // });

            let orderDetails = order.orderDetails;
            this.patient.document = order.idPatient.identification;
            this.patient.fullname = order.idPatient.name;

            this.searchIdentification = order.idPatient.identification;
            this.searchIdentificationType = order.idPatient.idIdentificationType.code;

            let response2 = await servicePatient.prioritizedPatient(
                this.searchIdentification,
                this.searchIdentificationType
            );
            let patient = response2.data;
            if (!patient.code) {
                // this.order.notApplyShippingFee = true
                // this.disableShippingFee = true
                this.isPrioritizedPatient = true
                    // this.isPAC = patient.isPAC
                    // this.hasPolicy = patient.hasPolicy
            }

            orderDetails.forEach(orderDetail => {
                this.orderCode = orderDetail.code;
                this.scaleFee = orderDetail.slidingScaleFee;
                this.deliveryNumber = orderDetail.number;
                this.paymentType = orderDetail.paymentType;
                this.patientName = orderDetail.patientName ? orderDetail.patientName : this.patient.fullname;
                this.patientIdentification = orderDetail.patientIdentification ? orderDetail.patientIdentification : this.patient.document;
                if (orderDetail.idProvider) {
                    this.providerOD = orderDetail.idProvider.id;
                }
                this.initialProvider = null
                if (orderDetail.initialProvider) {
                    this.initialProvider = orderDetail.initialProvider;
                }

                this.addOrderDetail(false, orderDetail.id, orderDetail.status);
                if (order.id) {
                    this.cancelReason = orderDetail.cancelReason;
                    this.datePreviewDelivery = orderDetail.date_PreviewDelivered;
                }

                if (orderDetail.orderDetailMedicines) {
                    orderDetail.orderDetailMedicines.forEach(medicine => {
                        this.plu = medicine.pluCode;
                        this.description = medicine.description;
                        this.count = medicine.quantity;
                        this.nextShippingDate = medicine.nextShippingDate;
                        this.selectOrderCode = orderDetail.code;
                        this.addMedicines(false, medicine.id, medicine.idMedicineCondition);
                    });
                }
                if (this.isNewOrder) {
                    this.updateOrderType();
                }
            });



            this.isUnifiedPharmacy = false
            if (order.idCity) {

                // if (order.idProviderScheduleRange.idBranch.idProvider.name === 'FARMACIA UNIFICADA') {
                //     this.isUnifiedPharmacy = true
                // }

                this.location.branch = order.idProviderScheduleRange ? order.idProviderScheduleRange.idBranch.id : order.idPolicyScheduleRange.idBranch.id;
                this.location.city = order.idCity.id;
                this.lastCitySelected = order.idCity.id;
                this.location.state = order.idCity.idState.id;
                await this.getBranches(order);
                await this.getStates(order);

                this.location.branch = order.idProviderScheduleRange ? order.idProviderScheduleRange.idBranch.id : order.idPolicyScheduleRange.idBranch.id;
                this.location.city = order.idCity.id;
                this.lastCitySelected = order.idCity.id;
                this.location.state = order.idCity.idState.id;
                await this.getCities(order);

                this.location.scheduleRange = order.idProviderScheduleRange ? order.idProviderScheduleRange.id : order.idPolicyScheduleRange.id;

            } else {
                this.location.scheduleRange = "";
                this.location.branch = "";
                this.location.city = "";
                this.location.state = "";
                await this.getStates();
            }
            console.log("entro en sheduling 6", this.location.city)
            if (order.id) {
                // this.getDate();
                this.order.deliveryDate = order.shippingDate;
            }

            if (order.id) {
                this.attachments = []
                for (let i = 0; i < order.attachments.length; i++) {
                    const attachment = order.attachments[i];
                    const arr = new Uint8Array(attachment.data.data);
                    const blob = new Blob([arr], { type: 'application/pdf' });
                    let fileURL = window.URL.createObjectURL(blob);
                    this.URLAttachments.push(fileURL)
                    this.attachments.push({ name: attachment.fileName })
                }
                this.showDownloadAttachment = true
            }

            this.observation = ''
            if (order.id) {
                this.observation = order.observation
            }

            this.note = order.note;

            this.authorizationsLoaded = true;
            this.listsupport();
            this.listhistory();
            this.patient = {};
            this.loading = false
            return true;
        },
        getPendingReason() {
            pendingReasonsService.getPendings().then(response => {
                console.log("response.data",response.data)
                this.pendingReasonItems = response.data
            })
        },
        getPendingReasonName(id) {
            let pendingReasonItem = this.pendingReasonItems.find(
                item => item.id === id
            )
            return pendingReasonItem ? pendingReasonItem.name : ''
        },
        async validateUser () {
            try {
                const parameter = (await parametersService.getParameterById(4)).data;
                const user = StorageService.getUserData();
                if (parseInt(parameter.value) === user.rol) {
                    this.userIsAdmin = true
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getNoteText () {
            try {
                this.noteText= ((await parametersService.getParameterById(6)).data).value;
            } catch (error) {
                console.log(error)
            }
        },
        async getCancelReasons () {
            serviceOrder.getTypeAuthorizationOrder().then(result => {
                // this.listhistory();
                this.typeCancelAuthorization = result.data
                this.cancelReasonSpecialMedicine = this.typeCancelAuthorization.find(cr => cr.name === 'El medicamento debe ser reclamado en farmacia').name
            });
            serviceOrder.getTypePedidoOrder().then(result => this.typeCancelOrder = result.data);
        },
        disableButton() {
            if (
                this.patient.type == "" ||
                this.patient.document == "" ||
                this.patient.fullname == "" ||
                this.state == "" ||
                this.city == "" ||
                this.appointmentDate == "" ||
                this.scheduleRange == ""
            ) {
                return (this.buttonDisabled = true);
            }
        },
        async saveAppointment() {
            try {
                this.loadingSave = true
                if (this.patient.type === '' || this.patient.type === undefined || this.patient.type === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el tipo de documento del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.document === '' || this.patient.document === undefined || this.patient.document === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número de documento del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.fullname === '' || this.patient.fullname === undefined || this.patient.fullname === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el nombre del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.cellPhoneNumber === '' || this.patient.cellPhoneNumber === undefined || this.patient.cellPhoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número celular del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.phoneNumber === '' || this.patient.phoneNumber === undefined || this.patient.phoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número de teléfono del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.cellPhoneNumber[0] !== '3' || this.patient.cellPhoneNumber.length !== 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número celular tiene un formato erróneo'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.phoneNumber.length < 7 || this.patient.phoneNumber.length > 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número de teléfono tiene un formato erróneo'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.deliveryPoint === '' || this.deliveryPoint === undefined || this.deliveryPoint === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un punto de entrega'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.appointmentDate === '' || this.appointmentDate === undefined || this.appointmentDate === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar una fecha de cita'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.scheduleRange === '' || this.scheduleRange === undefined || this.scheduleRange === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un horario de atención'
                    });
                    this.loadingSave = false
                    return;
                }
                let formData = {
                    patient: this.patient,
                    city: this.city,
                    date: this.appointmentDate,
                    scheduleRange: this.scheduleRange,
                    deliveryPoint: this.deliveryPoint,
                    observation: this.observation,
                    userIsAdmin: this.userIsAdmin,
                    user: StorageService.getUserData().id,
                    medicines: this.medicines
                };
                this.disableSaveButton = true;

                const response = await AppointmentService.saveAppointment(
                    formData
                );
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita agendada correctamente"
                });
                this.loadingSave = false
                this.closeAppointment(true);
            } catch (error) {
                if (error.message === 'Full capacity') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "El horario seleccionado ya no se encuentra disponible"
                    });
                    this.loadingSave = false
                } else {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Ha ocurrido un error al agendar el pedido"
                    });
                    this.loadingSave = false
                }
            } 
        },
        async editAppointment() {
            try {
                this.loadingEdit = true;
        
                // Validaciones de campos obligatorios
                if (!this.patient.type || !this.patient.document || !this.patient.fullname || !this.patient.cellPhoneNumber || !this.patient.phoneNumber ||
                    this.patient.type === '' || this.patient.document === '' || this.patient.fullname === '' || this.patient.cellPhoneNumber === '' || this.patient.phoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar todos los datos del paciente'
                    });
                    this.loadingEdit = false;
                    return;
                }
        
                if (this.patient.cellPhoneNumber[0] !== '3' || this.patient.cellPhoneNumber.length !== 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número celular tiene un formato erróneo'
                    });
                    this.loadingEdit = false;
                    return;
                }
        
                if (this.patient.phoneNumber.length < 7 || this.patient.phoneNumber.length > 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número de teléfono tiene un formato erróneo'
                    });
                    this.loadingEdit = false;
                    return;
                }
        
                if (!this.deliveryPoint || this.deliveryPoint === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un punto de entrega'
                    });
                    this.loadingEdit = false;
                    return;
                }
        
                if (!this.appointmentDate || this.appointmentDate === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar una fecha de cita'
                    });
                    this.loadingEdit = false;
                    return;
                }
        
                if (!this.scheduleRange || this.scheduleRange === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un horario de atención'
                    });
                    this.loadingEdit = false;
                    return;
                }
        
                // Validaciones de medicinas
                this.medicines.forEach(medicine => {
                    if (medicine.count - medicine.deliveredCount !== 0 && !medicine.pendingReason) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Por favor seleccione un motivo pendiente para todas las medicinas.",
                            duration: 5000
                        });
                        this.errordispenzation = true;
                        this.disableSaveButton = false;
                        this.loadingEdit = false;
                        this.loadingsave = false;
                        throw new Error('Validation failed');
                    }
                });
        
                // Preparar el formulario para la solicitud
                let formData = {
                    patients: [{
                        "documentType": this.patient.type,
                        "document": this.patient.document,
                        "fullname": this.patient.fullname,
                        "address": this.address,
                        "mobilePhone": this.patient.cellPhoneNumber,
                        "phone": this.patient.phoneNumber,
                        "idIncomeGroup": this.patient.idIncomeGroup ? this.patient.idIncomeGroup.id : "-",
                        "isPac": this.patient.PAC,
                        "isPolicy": this.patient.policy
                    }],
                    orderData: {
                        "orderDetail": this.medicines.map(medicine => ({
                            "orderCode": medicine.orderCode,
                            "scaleFee": medicine.scaleFee,
                            "status": this.status,
                            "patientName": this.patient.fullname,
                            "patientIdentification": this.patient.document,
                            "medicines": [{
                                "check": true,
                                "fullname": this.patient.fullname,
                                "document": this.patient.document,
                                "Idmedicine": this.orderDetailAppointment.appointmentMedicines[this.medicines.indexOf(medicine)].id,
                                "plu": medicine.plu,
                                "description": medicine.description,
                                "count": medicine.count,
                                "deliveredCount": medicine.deliveredCount,
                                "orderCode": medicine.orderCode,
                //                 "providerName":"HELPHARMA",
                                //   "providerId":2,
                                "scaleFee": medicine.scaleFee,
                                //   "deliveryNumber":"/1",
                                "status": this.status,
                                //   "paymentType":"CUOTA MODERADORA",
                                //   "isApplicable":false,
                                //   "isWatched":false,
                                //   "isFeatured":false,
                                //   "datePreviewDelivery":"",
                                //   "datePicker":false,
                                 "typeCancelAuthorization": medicine.typeCancelAuthorization,
                                "pendingmedicine": medicine.pendingmedicine ? medicine.pendingmedicine : 0,
                                "pendingReason": medicine.pendingReason
                            }
                            ]
                            
                        })),
                        // "typeUserOrder":null,
                    },
                    
                    observation: this.observation,
                    userId: await this.getUserId(),
                    provider: this.providerId
                };
        
                this.disableSaveButton = true;
        
                // Realizar la solicitud de edición solo si no se lanzó una excepción de validación
                let responseScheduling = await kardex.delivered_medicine(formData);
        
                // Notificar éxito
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita modificada correctamente"
                });
        
                this.loadingEdit = false;
                this.closeAppointment(true);
            } catch (error) {
                if (error.message !== 'Validation failed') {
                    if (error.message === 'Full capacity') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "El horario seleccionado ya no se encuentra disponible"
                        });
                    } else {
                        console.log("error", error);
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Ha ocurrido un error al agendar el pedido"
                        });
                    }
                    this.loadingEdit = false;
                }
            }
        },
        closeAppointment(reloadAppointments) {
            this.patient = {
                id: "",
                type: "",
                document: "",
                fullname: "",
                cellPhoneNumber: "",
                phoneNumber: ""
            };
            this.medicines = []
            this.state = ''
            this.city = ''
            this.scheduleRange = ''
            this.address = ''
            this.status = ''
            this.orderDetailAppointment={}
            if (reloadAppointments) {
                this.orderDetailAppointment=this.$refs.appointmentList.getAppointments();
            }
            this.newAppointment = true
            this.userIsAdmin = false
            this.id = ''
            this.selectedDP = {
                name: '',
                address: ''
            }
            this.selectedSR = {
                range: ''
            }
            this.showGrid = true
        },

        clearAppointment() {
            this.patient = {
                id: "",
                type: this.patient.type,
                document: this.patient.document,
                fullname: "",
                cellPhoneNumber: "",
                phoneNumber: ""
            };
            this.medicines = []
            this.state = ''
            this.city = ''
            this.scheduleRange = ''
            this.address = ''
            this.status = ''
            this.newAppointment = true
            this.id = ''
            this.selectedDP = {
                name: '',
                address: ''
            }
            this.selectedSR = {
                range: ''
            }
        },

        contains(arr, id) {
            return arr.some(e => e.id === id);
        },
        filterKeyCount(e) {
            const key = e.key;
            if (/[0-9]/.test(key)) {} else {
                return e.preventDefault();
            }
        },

        filterKey(e) {
            const key = e.key;
            if (/[0-9--]/.test(key)) {} else {
                return e.preventDefault();
            }
        },
        filterKeyletters(e) {
            const key = e.key;
            if (/[A-Za-z- ]/.test(key)) {} else {
                return e.preventDefault();
            }
        },

        showError(text) {
            this.$notify({
                group: "app",
                type: "error",
                text
            });
        },

        customFilter(item, queryText, itemText) {
        console.log("item",item)
            const textOne = item.description.toLowerCase();
            const textTwo = item.plu.toLowerCase();
            const searchText = queryText.toLowerCase();

            return (
                textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            );
        },

        getDocumentTypes() {
            serviceDocument.getDocuments().then(response => {
                this.documentTypeItems = response.data;
            });
        },

        getMedicines(order) {
            let medicines = []
            for (let i = 0; i < order.orderDetails.length; i++) {
                const od = order.orderDetails[i];
                console.log("order.orderDetails[i]",order.orderDetails[i])
                for (let j = 0; j < od.orderDetailMedicines.length; j++) {
                    const medicine = od.orderDetailMedicines[j];
                    medicines.push({
                        orderCode: od.code,
                        plu: medicine.pluCode,
                        description: medicine.description,
                        count: medicine.quantity,
                        scaleFee: od.slidingScaleFee,
                        deliveredCount: od.count,
                        pendingmedicine:od.count-deliveredCount,
                    })
                }
            }
            return medicines
        },
        maxNumberOfField(medicine) {
            // this.orderDetails.forEach(order => {

                if (medicine.deliveredCount > medicine.count) {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'El numero de la cantidad entregada no debe ser superior al de la cantidad.'
                    })
                }
            // });
        },
        onlyNumber(e) {
            const key = e.key;
            if (key === '.' || key === '-')
                return e.preventDefault();
        },
        async searchPatient() {
            if (!this.patient.type) {
                this.showError(i18n.t("no-options-selected-for-document-type"));
                return;
            }

            if (!this.patient.document) {
                this.showError(i18n.t("no-patient-id"));
                return;
            }

            this.clearAppointment()

            try {
                let response = await serviceOrder.getAuthorizations(this.patient.type, this.patient.document)
                this.medicines = this.getMedicines(response.data)
                console.log("this.medicines",this.medicines);
                this.patient.fullname = response.data.orderPatients[0].idPatient.name
                this.userWithAuthorizations = true;
            } catch (error) {
                console.log(error)
                this.userWithAuthorizations = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "No se han encontrado autorizaciones para el paciente especificado."
                });
                return
            }

            try {
                let response = await PatientService.getByDocument(
                    this.patient.type,
                    this.patient.document
                )
                const data = response.data;
                this.patient.id = data.id;
                // this.patient.fullname = data.name;
                this.patient.address = data.address;
                this.patient.cellPhoneNumber = data.mobilePhone;
                this.patient.phoneNumber = data.phone;
            } catch (error) {
                // this.showError(i18n.t("patient-not-exist"));
            }
        },
        async getStates () {
            try {
                let response = await locationService.getStatesWithDeliveryPoint()
                this.states = response.data
                this.state = ''
                this.city = ''
            } catch (error) {
                this.$notify({
                group: "app",
                type: "error",
                text: 'Error consultando los departamentos'
                })
            }
        },
        async getCities () {
            try {
                const data = {
                    ids: [this.state]
                }
                let response = await locationService.getCitiesWithDeliveryPoint(data)
                this.cities = response.data
                this.city = ''
                this.deliveryPoint = ''
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error'
                })
            }
        },

        async getDeliveryPoints () {
            try {
                let response = await deliveryPointService.getByCity(this.city)
                this.deliveryPoints = response.data
                this.deliveryPoint = ''
                this.$forceUpdate()
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error'
                })
            }
        },
        async getAddressAndAllowedDates() {
            this.selectedDP = this.deliveryPoints.find(dp => dp.id == this.deliveryPoint);
            this.address = this.selectedDP.address ? this.selectedDP.address : "";

            try {
                let response = await serviceCalendar.getAllowedDates(this.deliveryPoint, this.userIsAdmin)
                this.enabledDays = response.data
                this.minDate = this.enabledDays[0].date
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error consultando calendario'
                })
            }            
        },
        getAllowedDates(testDate) {
            for (let i = 0; i < this.enabledDays.length; i++) {
                if (this.enabledDays[i].date == testDate) {
                    return testDate
                }
            }
        },
        async getScheduleRanges() {
            const selectedDate = this.enabledDays.find(date => date.date == this.appointmentDate)
            try {
                if (selectedDate) {
                    let response = await serviceCalendar.getScheduleRanges(selectedDate.id, this.userIsAdmin)
                    if (response.data.length === 0) {
                        this.$notify({
                            group: "app",
                            type: "warning",
                            text: 'No hay turnos disponibles para la fecha seleccionada'
                        })
                    } else {
                        this.scheduleRanges = response.data.map(sr => {
                            return {
                                capacity: sr.capacity,
                                consecutive: sr.consecutive,
                                enabled: sr.enabled,
                                id: sr.id,
                                maxCapacity: sr.maxCapacity,
                                range: dayjs(sr.range).format('hh:mm A')
                            }
                        })
                    }
                }
                this.scheduleRange = ''
            } catch (error) {
                console.log(error)
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error consultando los horarios para el dia seleccionado'
                })
            }
        },
        getSelectedScheduleRange () {
            this.selectedSR = this.scheduleRanges.find(sr => sr.id == this.scheduleRange);
        },
        async cancelApointment() {
            if (this.cancelReason === '') {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "No se ha seleccionado un motivo de cancelación"
                });
                return
            }
            try {
                await AppointmentService.cancelAppointment({ id: this.id, cancelReason: this.cancelReason, medicines: this.medicines })
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita cancelada con éxito."
                })
                this.dialog = false
                this.closeAppointment(true);
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Error al cancelar la cita"
                });
                this.dialog = false
            }
        },
        async attend() {
            try {
                await AppointmentService.attend({ id: this.id })
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita asistida"
                });
                this.closeAppointment(true);
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Error al cambiar el estado de la cita"
                });
            }
        },

        async handleOrder(appointment) {
            this.newAppointment = false
            this.id = appointment.id
            this.showGrid = !this.showGrid
            const patient = appointment.patient

            this.medicines = []
            appointment.appointmentMedicines.forEach(medicine => {
                this.medicines.push({
                    orderCode: medicine.authorization,
                    plu: medicine.plu,
                    description: medicine.description,
                    count: medicine.quantity,
                    scaleFee: medicine.scaleFee,
                    deliveredCount: medicine.quantity,
                    pendingmedicine:(medicine.quantity- medicine.deliveredCount),
                })
            })

            this.userWithAuthorizations = true

            this.patient.id = patient.id
            this.patient.type = patient.idIdentificationType.id
            this.patient.document = patient.identification
            this.patient.fullname = patient.name
            this.patient.cellPhoneNumber = patient.mobilePhone
            this.patient.phoneNumber = patient.phone

            this.state = appointment.deliveryPoint.city.idState.id
            await this.getCities()
            this.city = appointment.deliveryPoint.city.id
            await this.getDeliveryPoints()
            this.deliveryPoint = appointment.deliveryPoint.id
            await this.getAddressAndAllowedDates()
            this.appointmentDate = appointment.date
            await this.getScheduleRanges()
            if (!this.contains(this.scheduleRanges, appointment.scheduleRangeAppointment.id)) {
                this.scheduleRanges.push({
                    id: appointment.scheduleRangeAppointment.id,
                    range: appointment.scheduleRangeAppointment.range
                })
            }
            this.scheduleRange = appointment.scheduleRangeAppointment.id
            this.getSelectedScheduleRange()
            this.status = appointment.status
            this.orderDetailAppointment=appointment
            this.observation = appointment.observation
            this.cancelReasonToShow = appointment.cancelReason
        },
        validateNumberCellphone() {
            if (this.patient.cellPhoneNumber[0] == '' || this.patient.cellPhoneNumber[0] == undefined) {
              return
            }
            if (this.patient.cellPhoneNumber[0] != '3') {
              this.$notify({
                group: "app",
                type: "error",
                text: "El número celular debe empezar con el número 3."
              })
            }
            if (this.patient.cellPhoneNumber.length == 10) {
              this.buttonDisabled = true;
              let count = 0;
              for (let i = 0; i < this.patient.cellPhoneNumber.length; i++) {
                let numberInitial = this.patient.cellPhoneNumber[0]
      
                if (numberInitial == this.patient.cellPhoneNumber[i]) {
                  count += 1;
                }
              }
              if (count >= 7) {
                this.buttonDisabled = false;
                this.$notify({
                 group: "app",
                 type: "error",
                 text: "Número inválido."
                })
              }
            }
          },
          validateNumberphone() {
            if (this.patient.phoneNumber[0] == '' || this.patient.phoneNumber[0] == undefined) {
              return
            }
            if (this.patient.phoneNumber.length >= 7) {
              this.buttonDisabled = true;
              let count = 0;
              for (let i = 0; i < this.patient.phoneNumber.length; i++) {
                let numberInitial = this.patient.phoneNumber[0]
      
                if (numberInitial == this.patient.phoneNumber[i]) {
                  count += 1;
                }
              }
              if (count >= 7) {
                this.buttonDisabled = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Número inválido."
                })
              }
            }
          }        
    },
    watch: {
       
        cellPhoneNumber() {
            this.validateNumberCellphone()
          },
        phoneNumber() {
            this.validateNumberphone()
          },
    },
    computed: {
        filteredHeaders() {
            if (this.status === 'SCHEDULED' || this.status === 'AGENDADA') {
                return this.headers;
            } else {
              return this.headers.filter(header => header.value !== 'deliveredCount' && header.value !== 'pendingmedicine' && header.value !== 'pendingReason');
            }
          },
        phoneNumber() {
            return this.patient.phoneNumber;
        },
        cellPhoneNumber(){
            return this.patient.cellPhoneNumber;
        },
        notes: {
            get() {
                return (
                    `Su cita queda programada para el día ${this.appointmentDate},` +
                    `en el horario ${this.selectedSR.range} ` +
                    `en el punto de entrega ${this.selectedDP.name}. ` +
                    `${this.noteText}`
                );
            },
            set(notes) {
                this.notes = notes;
            }
        }
    }
};